import React from "react";
import { Container, Typography, Grid, Paper, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import "animate.css";

// Styled components
const SectionContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 0),
  backgroundColor: "#121212",
  color: "#fff",
}));

const GalleryImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "250px",
  objectFit: "cover",
  borderRadius: theme.shape.borderRadius,
  transition: "transform 0.5s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 6px 20px rgba(255, 255, 0, 0.3)",
  },
}));

const ImageWrapper = styled(Paper)(({ theme }) => ({
  overflow: "hidden",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#1e1e1e",
  border: "1px solid #333",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
}));

const galleryImages = [
  { id: 1, src: "/images/33.jpg", alt: "Salon Interior 1" },
  { id: 2, src: "/images/31.jpg", alt: "Salon Interior 2" },
  { id: 8, src: "/images/26.jpg", alt: "Salon Hair style" },
  { id: 3, src: "/images/24.jpg", alt: "Salon Interior 3" },
  { id: 4, src: "/images/30.jpg", alt: "Salon Interior 4" },
  { id: 5, src: "/images/35.jpg", alt: "Salon Interior 5" },
  { id: 6, src: "/images/23.jpg", alt: "Salon Interior 6" },
  { id: 7, src: "/images/34.jpg", alt: "Salon Interior 7" },
];

const Gallery = () => {
  return (
    <SectionContainer>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          className="animate__animated animate__fadeInDown"
          sx={{ fontWeight: 600, color: "yellow", marginBottom: 5 }}
        >
          Our Salon Gallery
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {galleryImages.map((image, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={image.id}
              className={`animate__animated animate__fadeInUp`}
              style={{
                animationDelay: `${idx * 0.1}s`,
                animationDuration: "1s",
              }}
            >
              <ImageWrapper elevation={6}>
                <GalleryImage src={image.src} alt={image.alt} />
              </ImageWrapper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </SectionContainer>
  );
};

export default Gallery;
